<section class="chart">
  <div class="chart-wrapper">
    <div class="chart-container">
      <div echarts [options]="chartOptions" class="line-chart"></div>
    </div>
  </div>
</section>
